import {
  CLASSIC_LENS_TAB,
  LOOKS_TAB,
  MAKEUP_TAB,
  FRESH_LENS_TAB,
  showFreshTab,
  showLooksTab,
  showMakeupTab,
  showClassicTab
} from 'Root/constants';

const tabs = [
  {
    id: 'tabs.fresh_lenses',
    title: FRESH_LENS_TAB,
    className: 'tabs--color__fresh',
    data: FRESH_LENS_TAB,
    show: showFreshTab,
  },
  {
    id: 'tabs.classic_lenses',
    title: CLASSIC_LENS_TAB,
    className: 'tabs--color__classic',
    data: CLASSIC_LENS_TAB,
    show: showClassicTab,
  },
  {
    id: 'tabs.looks',
    title: LOOKS_TAB,
    className: 'tabs--color__looks',
    data: LOOKS_TAB,
    show: showLooksTab,
  },
  {
    id: 'tabs.makeup',
    title: MAKEUP_TAB,
    className: 'tabs--color__makeup',
    data: MAKEUP_TAB,
    show: showMakeupTab,
  },
].filter((item) => item.show);

export { tabs };
